import styled from "styled-components";
import { SIZES } from "@/components/constants";
import {useSectionActive} from "@/app/[locale]/services/useSectionActive";
import {useMediaQuery} from "react-responsive";


const HeroSection = ({ data, index, activeIndex }) => {
    const isTablet = useMediaQuery(
        { query: `(max-width: ${SIZES.TABLET})` },
        undefined,
        () => false
    );

    const sectionActive = index <= activeIndex;

    const titleRef = useSectionActive(sectionActive);

    const asisRef = useSectionActive(sectionActive, {
        offset: isTablet ? 0 : 0,
        delay: isTablet ? 0 : 0.2,
    });

    const tobeRef = useSectionActive(sectionActive, {
        offset: isTablet ? 0 : 20,
        delay: isTablet ? 0 : 0.4,
    });
    return (
        <SectionWrap>
            <div className={"container"}>
                <div className={"title-wrap"} ref={titleRef}>
                    <div className={"sub-text"}>
                        <span className={"material-symbols-rounded"}>check_circle</span>
                        <span dangerouslySetInnerHTML={{__html: data["service-top-text"]}}/>
                    </div>
                    <h1 className={"tittle-text"} dangerouslySetInnerHTML={{__html: data["service-top-title"]}}/>
                    <p className={"desc-text"} dangerouslySetInnerHTML={{__html: data["service-top-desc"]}}/>
                </div>

                <div className={"hero-area"}>
                    <div className={"hero-wrap"}>
                        <div id={"panel-asis"} ref={asisRef}  className={"hero-item hero-asis"}>
                            <div className={"hero-head hero-asis-head"}>
                                <div className={"head-row"}>
                                    <h2
                                        className={"hero-title"}
                                        dangerouslySetInnerHTML={{__html: data["service-card1-top1"]}}
                                    />
                                    <span
                                        className={"hero-badge hero-badge-red"}
                                        dangerouslySetInnerHTML={{__html: data["service-card1-top2"]}}
                                    />
                                </div>
                                <p
                                    className={"hero-sub"}
                                    dangerouslySetInnerHTML={{__html: data["service-card1-top3"]}}
                                />
                            </div>

                            <div className={"hero-body hero-asis-body"}>
                                <div className={"asis-flow"}>
                                    <div className={"flow-col flow-col-muted"}>
                                        <span
                                            className={"flow-tag"}
                                            dangerouslySetInnerHTML={{__html: data["service-card1-text1"]}}
                                        />
                                        <div className={"flow-card"}>
                                            <span className={"material-symbols-rounded flow-ico"}>local_shipping</span>
                                            <div
                                                className={"flow-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card1-text2"]}}
                                            />
                                        </div>
                                        <div className={"flow-line-dash"}/>
                                        <div className={"flow-card"}>
                                            <div
                                                className={"flow-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card1-text3"]}}
                                            />
                                        </div>
                                        <div className={"flow-line-dash"}/>
                                        <div className={"flow-card"}>
                                            <div
                                                className={"flow-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card1-text4"]}}
                                            />
                                        </div>
                                        <div className={"flow-line-dash flow-line-dash-sm"}/>
                                        <div className={"flow-card flow-card-sunken"}>
                                            <div className={"flow-trash"}>
                                                <span className={"material-symbols-rounded"}>delete</span>
                                                <div
                                                    className={"flow-card-title"}
                                                    dangerouslySetInnerHTML={{__html: data["service-card1-text5"]}}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className={"flow-divider"}/>

                                    <div className={"flow-col"}>
                                        <span
                                            className={"flow-tag"}
                                            dangerouslySetInnerHTML={{__html: data["service-card1-text6"]}}
                                        />
                                        <div className={"flow-card"}>
                                            <span className={"material-symbols-rounded flow-ico"}>sprint</span>
                                            <div
                                                className={"flow-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card1-text7"]}}
                                            />
                                        </div>
                                        <div className={"flow-line-dash"}/>
                                        <div className={"flow-card"}>
                                            <div
                                                className={"flow-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card1-text8"]}}
                                            />
                                        </div>
                                        <div className={"flow-line-dash"}/>
                                        <div className={"flow-card"}>
                                            <div
                                                className={"flow-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card1-text9"]}}
                                            />
                                        </div>
                                        <div className={"flow-line-dash flow-line-dash-sm"}/>
                                        <div className={"flow-issue"}>
                                            <div className={"flow-issue-title"} dangerouslySetInnerHTML={{__html: data["service-card1-text10"]}}/>
                                            <div className={"flow-issue-desc"} dangerouslySetInnerHTML={{__html: data["service-card1-text11"]}}/>
                                            <div className={"flow-issue-x"}>X</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="hero-divide">VS</div>

                        <div id={"panel-tobe"} ref={tobeRef}  className={"hero-item hero-tobe"}>
                            <div className={"hero-head hero-tobe-head"}>
                                <div className={"tobe-head-left"}>
                                    <h2 className={"hero-title hero-title-white"}>
                                        <span dangerouslySetInnerHTML={{__html: data["service-card2-top1"]}}/>
                                        <span className={"hero-pill"}
                                              dangerouslySetInnerHTML={{__html: data["service-card2-top2"]}}/>
                                    </h2>
                                    <p className={"hero-sub hero-sub-green"} dangerouslySetInnerHTML={{__html: data["service-card2-top3"]}}/>
                                </div>
                                <span className={"material-symbols-rounded tobe-recycle"}>recycling</span>
                            </div>

                            <div className={"hero-body hero-tobe-body"}>
                                <div className={"tobe-bg"}>
                                    <div className={"tobe-texture"} />
                                    <div className={"tobe-glow tobe-glow-a"} />
                                    <div className={"tobe-glow tobe-glow-b"} />
                                </div>

                                <svg className={"tobe-lines"}>
                                    <line x1={"50%"} y1={"18%"} x2={"50%"} y2={"30%"} />
                                    <line x1={"50%"} y1={"42%"} x2={"50%"} y2={"54%"} />
                                    <line x1={"50%"} y1={"66%"} x2={"50%"} y2={"78%"} />
                                </svg>

                                <div className={"tobe-flow"}>
                                    <div className={"tobe-step tobe-step-1"}>
                                        <div className={"tobe-step-num"}>1</div>
                                        <div
                                            className={"tobe-step-title"}
                                             dangerouslySetInnerHTML={{__html: data["service-card2-text1"]}}
                                        />
                                        <div
                                            className={"tobe-step-desc"}
                                             dangerouslySetInnerHTML={{__html: data["service-card2-text2"]}}
                                        />
                                        <div className={"arrow-left"}></div>
                                    </div>

                                    <div className={"tobe-card"}>
                                    <div className={"tobe-ico"}>
                                            <span className={"material-symbols-rounded"}>person</span>
                                        </div>
                                        <div>
                                            <div
                                                className={"tobe-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card2-text3"]}}
                                            />
                                            <div
                                                className={"tobe-card-desc"}
                                                dangerouslySetInnerHTML={{__html: data["service-card2-text4"]}}
                                            />
                                        </div>
                                    </div>

                                    <div className={"tobe-card"}>
                                        <div className={"tobe-ico"}>
                                            <span className={"material-symbols-rounded"}>water_drop</span>
                                        </div>
                                        <div>
                                            <div
                                                className={"tobe-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card2-text5"]}}
                                            />
                                            <div
                                                className={"tobe-card-desc"}
                                                dangerouslySetInnerHTML={{__html: data["service-card2-text6"]}}
                                            />
                                        </div>
                                    </div>

                                    <div className={"tobe-card"}>
                                        <div className={"tobe-ico"}>
                                            <span className={"material-symbols-rounded"}>check_circle</span>
                                        </div>
                                        <div>
                                            <div
                                                className={"tobe-card-title"}
                                                dangerouslySetInnerHTML={{__html: data["service-card2-text7"]}}
                                            />
                                            <div
                                                className={"tobe-card-desc"}
                                                dangerouslySetInnerHTML={{__html: data["service-card2-text8"]}}
                                            />
                                        </div>
                                    </div>

                                    <div className={"tobe-brand"}>
                                        <span
                                            className={"tobe-brand-top"}
                                            dangerouslySetInnerHTML={{__html: data["service-card2-text9"]}}
                                        />
                                        <div
                                            className={"tobe-brand-name"}
                                            dangerouslySetInnerHTML={{__html: data["service-card2-text10"]}}
                                        />
                                        <div
                                            className={"tobe-brand-sub"}
                                            dangerouslySetInnerHTML={{__html: data["service-card2-text11"]}}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"hero-list"}>
                        <div className={"hero-list-item"}>
                            <div className={"list-icon"}>
                                <span className={"material-symbols-rounded"}>monitoring</span>
                            </div>
                            <h3
                                className={"list-title"}
                                dangerouslySetInnerHTML={{__html: data["service-card3-text1"]}}
                            />
                        </div>

                        <div className={"hero-list-item sec"}>
                            <div className={"list-icon"}>
                                <span className={"material-symbols-rounded"}>price_check</span>
                            </div>
                            <h3
                                className={"list-title"}
                                dangerouslySetInnerHTML={{__html: data["service-card4-text1"]}}
                            />
                        </div>

                        <div className={"hero-list-item third"}>
                            <div className={"list-icon"}>
                                <span className={"material-symbols-rounded"}>public</span>
                            </div>
                            <h3
                                className={"list-title"}
                                dangerouslySetInnerHTML={{__html: data["service-card5-text1"]}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </SectionWrap>
    );
};
const SectionWrap = styled.section`
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    gap: 120px;
    background-color: #f0f0f1;
    .title-wrap,
    .hero-asis,
    .hero-tobe {
        opacity: 0;
        transform: translateY(60px);
        transition: all 0.6s ease;
    }

    .title-wrap.is-show,
    .hero-asis.is-show,
    .hero-tobe.is-show {
        opacity: 1;
        transform: translateY(0);
    }
    .container {
        width: 100%;
        margin: 0 auto;
        padding: 0 24px;


        .title-wrap {
            text-align: center;
            padding: 0 0 40px;

            .sub-text {
                color: #047857;
                font-weight: 600;
                font-size: 14px;
                line-height: 20px;
                padding: 4px 12px;
                background-color: rgb(209 250 229 / 0.5);
                border: 1px solid #a7f3d0;
                border-radius: 9999px;
                gap: 6px;
                display: inline-flex;
                align-items: center;
                margin-bottom: 24px;

                span {
                    font-size: 14px;
                    line-height: 20px;
                }
            }

            .tittle-text {
                color: #0f172a;
                line-height: 1.25;
                font-weight: 800;
                font-size: 36px;
                margin-bottom: 24px;

                span {
                    color: transparent;
                    background-clip: text;
                    background-image: linear-gradient(to right, #059669, #14b8a6);
                }
            }

            .desc-text {
                color: #64748b;
                font-size: 18px;
                line-height: 28px;
                max-width: 672px;
                margin: 0 auto;

                strong {
                    font-weight: 700;
                }

                .mo {
                    display: block;
                }
            }
        }

        .hero-area {
            padding: 0 16px 8px;
            max-width: 1280px;
            margin: 0 auto;

            .hero-wrap {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: stretch;
                gap: 32px;

                .hero-item {

                    display: flex;
                    flex-direction: column;
                    border-radius: 24px;
                    overflow: hidden;
                }

                // VS (모바일 숨김)

                .hero-divide {
                    display: none; // ✅ mobile hidden
                    flex: 0 0 auto;
                    width: 56px;
                    height: 56px;
                    border-radius: 9999px;
                    background: #fff;
                    border: 4px solid #f8fafc;
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
                    align-items: center;
                    justify-content: center;
                    font-weight: 900;
                    font-style: italic;
                    font-size: 20px;
                    color: #e2e8f0;
                }

                /* ===== 공통 헤더 ===== */

                .hero-head {
                    padding: 24px;
                    border-bottom: 1px solid rgba(226, 232, 240, 0.8);

                    .head-row {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        gap: 12px;
                        margin-bottom: 8px;
                    }

                    .hero-title {
                        font-size: 24px;
                        line-height: 32px;
                        font-weight: 700;
                        color: #94a3b8;
                        transition: color 0.2s ease;
                    }

                    .hero-sub {
                        font-size: 14px;
                        color: #64748b;
                    }

                    .hero-title-white {
                        color: #fff;
                        display: flex;
                        align-items: center;
                        gap: 8px;
                    }

                    .hero-sub-green {
                        color: #a7f3d0;
                        margin-top: 4px;
                    }
                }

                .hero-badge {
                    font-size: 12px;
                    font-weight: 700;
                    padding: 4px 8px;
                    border-radius: 6px;
                    border: 1px solid transparent;
                    white-space: nowrap;
                }

                .hero-badge-red {
                    background: #fef2f2;
                    border-color: #fee2e2;
                    color: #dc2626;
                }

                /* ===== AS-IS ===== */

                .hero-asis {
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    box-shadow: 0 20px 25px rgba(0, 0, 0, 0.10), 0 10px 10px rgba(0, 0, 0, 0.04);

                    &:hover {
                        border-color: #fecaca;

                        .hero-asis-head .hero-title {
                            color: #f87171;
                        }

                        .flow-col-muted {
                            filter: grayscale(0);
                            opacity: 1;
                        }
                    }
                }

                .hero-asis-head {
                    background: #f8fafc;
                    border-bottom: 1px solid #f1f5f9;
                }

                .hero-asis-body {
                    padding: 32px;
                    flex: 1;
                    position: relative;
                    background-image: radial-gradient(#e2e8f0 1px, transparent 1px);
                    background-size: 20px 20px;
                }

                .asis-flow {
                    display: flex;
                    gap: 16px;
                    height: 100%;
                }

                .flow-col {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 16px;
                    position: relative;
                }

                .flow-col-muted {
                    opacity: 0.6;
                    filter: grayscale(1);
                    transition: all 0.5s ease;
                }

                .flow-divider {
                    width: 1px;
                    background: #e2e8f0;
                }

                .flow-tag {
                    font-size: 12px;
                    font-weight: 700;
                    color: #94a3b8;
                    background: #f1f5f9;
                    padding: 4px 8px;
                    border-radius: 6px;
                }

                .flow-card {
                    width: 100%;
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    padding: 16px;
                    border-radius: 12px;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
                    text-align: center;
                }

                .flow-card-sunken {
                    background: #f1f5f9;
                    box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.08);
                    padding: 22px 12px;
                }

                .flow-ico {
                    display: inline-block;
                    font-size: 30px;
                    margin-bottom: 4px;
                    color: #94a3b8;
                }

                .flow-card-title {
                    font-weight: 700;
                    color: #475569;
                }

                .flow-line-dash {
                    height: 48px;
                    width: 0;
                    border-left: 2px dashed #cbd5e1;
                }

                .flow-line-dash-sm {
                    height: 32px;
                }

                .flow-trash {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    color: #94a3b8;

                    .material-symbols-rounded {
                        font-size: 18px;
                    }
                }

                .flow-issue {
                    width: 100%;
                    background: #fef2f2;
                    border: 1px solid #fee2e2;
                    padding: 18px 12px;
                    border-radius: 12px;
                    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
                    text-align: center;
                    position: relative;
                }

                .flow-issue-title {
                    font-size: 12px;
                    font-weight: 700;
                    color: #ef4444;
                }

                .flow-issue-desc {
                    font-size: 10px;
                    color: #f87171;
                    margin-top: 4px;
                }

                .flow-issue-x {
                    position: absolute;
                    right: -8px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 24px;
                    height: 24px;
                    border-radius: 999px;
                    background: #ef4444;
                    color: #fff;
                    font-weight: 700;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.18);
                }

                /* ===== TO-BE ===== */

                .hero-tobe {
                    background-image: linear-gradient(to bottom right, #064e3b, #134e4a);
                    border: 1px solid #065f46;
                    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
                    color: #fff;
                    position: relative;
                }

                .hero-tobe-head {
                    padding: 24px;
                    background-color: rgb(6 95 70 / 0.5);
                    backdrop-filter: blur(8px);
                    border-bottom: 1px solid rgb(4 120 87 / 0.5);
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 16px;
                    position: relative;
                    z-index: 2;
                }


                .hero-pill {
                    background: #10b981;
                    color: #fff;
                    font-size: 12px;
                    line-height: 16px;
                    padding: 2px 8px;
                    border-radius: 999px;
                    box-shadow: 0 0 #0000, 0 0 #0000, 0 10px 15px -3px rgb(16 185 129 / 0.5), 0 4px 6px -4px rgb(16 185 129 / 0.5);
                    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
                }

                .tobe-recycle {
                    font-size: 36px;
                    color: rgba(52, 211, 153, 1);
                    animation: spin 10s linear infinite;
                }

                .hero-tobe-body {
                    padding: 32px 32px;
                    flex: 1;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .tobe-bg {
                    position: absolute;
                    inset: 0;
                    pointer-events: none;
                    overflow: hidden;
                    z-index: 0;
                }

                .tobe-texture {
                    position: absolute;
                    inset: 0;
                    opacity: 0.1;
                    background-image: url("https://www.transparenttextures.com/patterns/cubes.png");
                }

                .tobe-glow {
                    position: absolute;
                    border-radius: 999px;
                    filter: blur(100px);
                }

                .tobe-glow-a {
                    width: 256px;
                    height: 256px;
                    right: -96px;
                    top: -96px;
                    background: #10b981;
                    opacity: 0.3;
                    animation: float 6s ease-in-out infinite;
                }

                .tobe-glow-b {
                    width: 320px;
                    height: 320px;
                    left: 0;
                    bottom: 0;
                    background: #14b8a6;
                    opacity: 0.2;
                }

                .tobe-lines {
                    position: absolute;
                    inset: 0;
                    width: 100%;
                    height: 100%;
                    z-index: 1;
                    pointer-events: none;

                    line {
                        stroke: #34d399;
                        stroke-width: 2;
                        stroke-dasharray: 6;
                        opacity: 0.9;
                        animation: dash 1.8s linear infinite;
                    }

                    path {
                        fill: none;
                        stroke: #10b981;
                        stroke-width: 2;
                        stroke-dasharray: 8;
                        opacity: 0.4;
                    }

                    .tobe-lines-strong {
                        stroke: #34d399;
                        opacity: 0.9;
                        animation: dash 1.8s linear infinite;
                    }
                }

                .tobe-flow {
                    position: relative;
                    z-index: 2;
                    width: 100%;
                    max-width: 360px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    gap: 24px;

                    &::before {
                        content: "";
                        width: 50%;
                        height: calc(100% - 82px);
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        border: 2px solid #828282;
                        transform: translateY(-50%);
                        border-left: none;
                        z-index: -1;
                    }
                }

                .tobe-step {
                    width: 100%;
                    background: #d1fae5;
                    color: #064e3b;
                    padding: 16px;
                    border-radius: 16px;
                    border: 2px solid #34d399;
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.18);
                    position: relative;
                    text-align: center;
                }

                .tobe-step-num {
                    position: absolute;
                    left: -12px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 24px;
                    height: 24px;
                    border-radius: 999px;
                    background: #10b981;
                    border: 2px solid #fff;
                    color: #fff;
                    font-weight: 700;
                    font-size: 12px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .tobe-step-title {
                    font-weight: 700;
                    font-size: 18px;
                    margin-bottom: 4px;
                }

                .tobe-step-desc {
                    font-size: 12px;
                    color: #047857;
                }

                .tobe-card {
                    width: 100%;
                    background: rgba(6, 78, 59, 0.8);
                    backdrop-filter: blur(8px);
                    border: 1px solid rgba(52, 211, 153, 0.35);
                    padding: 16px;
                    border-radius: 16px;
                    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.22);
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }

                .tobe-ico {
                    background: rgba(16, 185, 129, 0.25);
                    padding: 8px;
                    border-radius: 12px;

                    .material-symbols-rounded {
                        color: #a7f3d0;
                        font-size: 18px;
                    }
                }

                .tobe-card-title {
                    font-weight: 700;
                    font-size: 14px;
                }

                .tobe-card-desc {
                    font-size: 10px;
                    color: rgba(167, 243, 208, 0.85);
                    margin-top: 2px;
                }

                .tobe-brand {
                    margin-top: 8px;
                    background: rgba(255, 255, 255, 0.10);
                    backdrop-filter: blur(8px);
                    border: 1px solid rgba(16, 185, 129, 0.25);
                    border-radius: 12px;
                    padding: 12px 16px;
                    text-align: center;
                    animation: float 4s ease-in-out infinite;
                    max-width: 320px;
                    width: 100%;
                }

                .tobe-brand-top {
                    color: rgba(167, 243, 208, 0.85);
                    font-size: 12px;
                    font-weight: 700;
                    letter-spacing: 0.12em;
                }

                .tobe-brand-name {
                    font-size: 20px;
                    font-weight: 700;
                    line-height: 28px;
                }

                .tobe-brand-sub {
                    font-size: 10px;
                    color: rgba(167, 243, 208, 0.9);
                    margin-top: 4px;
                }
            }


            .hero-list {
                gap: 24px;
                display: grid;
                margin-top: 80px;

                .hero-list-item {
                    background: #fff;
                    padding: 24px;
                    border-radius: 16px;
                    border: 1px solid #f1f5f9;
                    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
                    transition: all 0.2s ease;
                    transform: translateY(0);

                    &:hover {
                        box-shadow: 0 10px 15px rgba(0, 0, 0, 0.10), 0 4px 6px rgba(0, 0, 0, 0.05);
                        transform: translateY(-4px);
                    }

                    .list-icon {
                        width: 48px;
                        height: 48px;
                        border-radius: 12px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #ecfdf5;
                        color: #059669;
                        margin-bottom: 16px;
                        transition: background-color 0.2s ease, color 0.2s ease; // transition-colors
                    }

                    &:hover {
                        .list-icon {
                            background: #059669;
                            color: #fff;
                        }
                    }

                    &.sec {
                        .list-icon {
                            background: #f0fdfa;
                            color: #0d9488;
                        }

                        &:hover {
                            .list-icon {
                                background: #0d9488;
                                color: #fff;
                            }
                        }
                    }

                    &.third {
                        .list-icon {
                            background: #eff6ff;
                            color: #2563eb;
                        }

                        &:hover {
                            .list-icon {
                                background: #2563eb;
                                color: #fff;
                            }
                        }
                    }

                    .list-title {
                        font-size: 18px;
                        font-weight: 700;
                        color: #1e293b;
                        margin-bottom: 8px;
                    }
                }

            }


        }

        .arrow-left {
            width: 14px;
            height: 14px;
            border-left: 2px solid #828282;
            border-bottom: 2px solid #828282;
            border-radius: 2px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%) rotate(45deg);
            right: -19px;
        }
    }


    @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
    }
    @keyframes float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-10px); }
    }
    @keyframes pulse {
        50% { opacity: .5; }
    }
    @keyframes dash {
        from { stroke-dashoffset: 0; }
        to { stroke-dashoffset: -16; }
    }
    @media (max-width: ${SIZES.TABLET_L}) {
        .container .hero-area .hero-wrap .tobe-flow::before{
            width: 52%;
        }
        .container .arrow-left{
            width: 12px;
            height: 12px;
            right: -16px;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .container .hero-area .hero-wrap .tobe-flow::before{
            width: 56.5%;
        }
        .container.arrow-left{
            width: 10px;
            height: 10px;
            right: -14px;
        }
    }
    @media (max-width: 420px) {
        .container .hero-area .hero-wrap .tobe-flow::before{
            width: 58.5%;
        }
    }
    @media (min-width: ${SIZES.MOBILE}) {
        .container {
            max-width: 640px;
            .hero-area {
                padding: 0 24px;
                .hero-list{
                    grid-template-columns: repeat(3, minmax(0, 1fr));
                }
            }
        }
    }

    @media (min-width: ${SIZES.MOBILE_L}) {
        .container {
            max-width: 768px;

            .title-wrap {
                .tittle-text {
                    font-size: 60px;
                    line-height: 1;
                }

                .desc-text {
                    .mo {
                        display: none;
                    }
                }
            }
            .hero-area{
                .hero-wrap{
                    flex-direction: row;
                    align-items: stretch;
                    gap: 5px;

                    .hero-divide {
                        display: flex;
                        align-self: center;
                    }

                    .hero-item{

                        flex: 1 1 0;
                        min-width: 0;   
                    }
                }
            }
            
        }
    }

    @media (min-width: ${SIZES.TABLET}) {
        gap: 133px;
        .container {
            max-width: 1024px;
            padding: 0 40px;

            .hero-area {
                padding: 0 32px 128px;
                .hero-wrap {
                    gap: 5px;
                    .tobe-step{
                        width: 256px;
                    }
                    .tobe-card{
                        width: 256px;
                    }
                }
            }
        }
    }

    @media (min-width: ${SIZES.TABLET_L}) {
        .container {
            max-width: 1280px;

            .title-wrap {
                padding: 0 0 80px;
            }
        }
    }

    @media screen and (min-width: ${SIZES.PC}) {
        .container {
            max-width: 1536px;
        }
    }
`;

export default HeroSection;
